module.exports = __webpack_public_path__ + "img/CS-Profi13_Overview-Spare_1.32e31a3e.jpg";